/**
 * CAPA DE LÓGICA DE NEGOCIO (BL): CARDS / DISCIPLINA
 * ------------------------------------------------------------------
 * Orquesta las reglas de negocio, validaciones de integridad de datos
 * y control de flujos antes de impactar la base de datos o el overlay.
 * ------------------------------------------------------------------
 */

import { 
    GetCardsState as DLGetCardsState, 
    ApplyCard as DLApplyCard, 
    ResetMatchCards as DLResetMatchCards,
    TriggerCardsOverlay as DLTriggerCardsOverlay
} from '../DL/Cards';

/**
 * Consulta el estado disciplinario actual del encuentro.
 */
const GetCardsState = async () => {
    try {
        const response = await DLGetCardsState();
        if (response.success) {
            return { success: true, data: response.data };
        }
        return { success: false, message: response.message };
    } catch (error) {
        return { success: false, message: 'No se pudo procesar la consulta disciplinaria en este momento.' };
    }
};

/**
 * Aplica las reglas de validación necesarias antes de registrar una tarjeta.
 * @param {Object} payload - Datos de la amonestación recopilados del formulario.
 */
const ApplyCard = async (payload) => {
    try {
        // --- VALIDACIONES DE INTEGRIDAD ---
        if (!payload.playerId || isNaN(payload.playerId)) {
            return { success: false, message: 'Es obligatorio seleccionar un jugador válido para aplicar la sanción.' };
        }

        if (!payload.infractionTitle || payload.infractionTitle.trim() === '') {
            return { success: false, message: 'Debes especificar el motivo o título de la infracción.' };
        }

        if (!payload.matchMinute || payload.matchMinute.trim() === '') {
            return { success: false, message: 'El minuto del partido es un dato obligatorio para la transmisión.' };
        }

        // Sanitización básica de strings para el overlay
        payload.infractionTitle = payload.infractionTitle.toUpperCase().trim();
        payload.matchMinute = payload.matchMinute.trim().includes("'") ? payload.matchMinute.trim() : `${payload.matchMinute.trim()}'`;

        // Ejecutar inserción en datos si pasa los filtros
        const response = await DLApplyCard(payload);
        
        if (response.success) {
            return { success: true, data: response.data };
        }
        return { success: false, message: response.message };

    } catch (error) {
        return { success: false, message: 'Ocurrió un error inesperado al procesar la lógica de la tarjeta.' };
    }
};

/**
 * Solicita el reinicio completo de las tarjetas con confirmación previa.
 */
const ResetMatchCards = async () => {
    try {
        const response = await DLResetMatchCards();
        if (response.success) {
            return { success: true };
        }
        return { success: false, message: response.message };
    } catch (error) {
        return { success: false, message: 'Error crítico al intentar resetear el juego.' };
    }
};

/**
 * Envía una señal de control directa al overlay (ej. close).
 */
const TriggerCardsOverlay = async (action, playerId = null) => {
    try {
        const response = await DLTriggerCardsOverlay(action, playerId);
        if (response.success) {
            return { success: true };
        }
        return { success: false, message: response.message };
    } catch (error) {
        return { success: false, message: 'Fallo al enviar señal al overlay.' };
    }
};

export { GetCardsState, ApplyCard, ResetMatchCards, TriggerCardsOverlay };